import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { isMobileWidth, isTabletWidth } from '../../util/util'

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  const isDesktop = breakpoint > 1024
  // const responsivePadding = getPadding(breakpoint)
  return {
    content: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      flexWrap: 'wrap',
      // paddingHorizontal: responsivePadding,
      mt: isTab || isMobile ? 10 : 40,
    } as BoxProps,
    whyJioTextContainer: (isTopLeft: boolean, isBottomRight: boolean, isTopRight: boolean, isBottomLeft: boolean) =>
      ({
        minWidth: isTab ? 336 : isMobile ? undefined : 260,
        minHeight: isTab ? (isTopLeft || isTopRight ? 268 : 288) : isMobile ? undefined : 380,
        width: isMobile ? breakpoint - 48 : breakpoint / 4 - (responsivePadding / 4) * 2,
        marginBottom: isTab || isMobile ? 0 : 20,
        marginTop: isMobile ? 24 : 0,
        padding: isDesktop ? 24 : isMobile ? 0 : 18,
        borderRadius: 8,
        // borderRightWidth: 0.3,
        // borderColor: '#E0E0E0',
        // borderBottomWidth: isTab && (isTopLeft || isTopRight) ? 0.3 : 0,
        // shadowColor: '#000',
        // shadowOffset: {
        //   width: 0,
        //   height: 0,
        // },
        // shadowOpacity: 0.2,
        // shadowRadius: 2,
        // borderTopLeftRadius: isTopLeft ? (isMobile ? 8 : 24) : 0,
        // borderBottomLeftRadius:
        //   isTab && isBottomLeft ? 24 : isMobile && isBottomRight ? 8 : !isMobile && !isTab && isTopLeft ? 24 : 0,
        // borderTopRightRadius: isTab ? (isTopRight ? 24 : 0) : isMobile ? (isTopLeft ? 8 : 0) : isBottomRight ? 24 : 0,
        // borderBottomRightRadius: isBottomRight ? (isMobile ? 8 : 24) : 0,
        zIndex: 10,
      } as ViewStyle),
    textContentOverlap: {
      minHeight: isMobile || isTab ? undefined : 265,
      maxWidth: isTab ? 336 : isMobile ? undefined : 180,
    } as BoxProps,
    ImageKeyborad: {
      width: 24,
      height: 24,
      marginTop: 5,
    } as ViewStyle,
    dimRightArrow: {
      width: 20,
      height: 20,
      opacity: 0.2,
      marginTop: 3,
    } as ViewStyle,
    whyjioArrow: {
      opacity: 0.2,
      marginTop: 8,
      marginLeft: 8,
    } as ViewStyle,
    whyjiodime: {
      marginBottom: isMobile || isTab ? 4 : 10,
      marginTop: 24,
    } as ViewStyle,
    whyjiofix: {
      minHeight: isMobile ? '50vh' : undefined,
      height: isTab ? undefined : '100%',
      w: '100%',
    } as BoxProps,
    whyjiocontainer: {
      display: 'flex',
      width: '100%',
      zIndex: 10,
      flexDirection: 'row',
      // justifyContent: 'center',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    } as BoxProps,
    merchantPartner: {
      position: 'absolute',
      left: isMobile || isTab ? 60 : 130,
      // top: 100,
      alignSelf: 'center',
    } as BoxProps,
    dotImageContainer: {
      position: 'absolute',
      left: isMobile ? 30 : isTab ? 80 : responsivePadding + 5,
      zIndex: -99,
      top: isMobile ? -10 : isTab ? -25 : -30,
    } as BoxProps,
    borderLine: {
      width: breakpoint - 48,
      backgroundColor: 'BORDER_COLOR',
      height: -5,
      alignSelf: 'center',
    } as BoxProps,
  }
}
